import useStore from 'base/store'
import {PermissionType} from 'common/types'
import {ListTabsPanel} from 'common/components'
// import styles from './TopPanel.module.scss'
import {AddButton} from './AddButton'

const tabs = [
  {key: '', label: 'Users'},
]

export default function TopPanel() {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  return (
    <ListTabsPanel
      noGap
      path="users"
      tabs={tabs}
      action={
        permissions?.includes('create user') && 
        (
          // <div className={styles.block}>
            <AddButton />
          // </div>
        )
      }
    />
  )
}
